import { joinURL, withQuery } from 'ufo'
type Link = {
  rel: string
  href: string
}

const getPrevLink = ({
  url,
  currentPage,
}: {
  url: string
  currentPage: number
}): Link[] => {
  if (currentPage === 1) return []
  const previousPage = currentPage - 1
  return [
    {
      rel: 'prev',
      href: previousPage > 1 ? withQuery(url, { page: previousPage }) : url,
    },
  ]
}

const getNextLint = ({
  url,
  currentPage,
  pagesCount,
}: {
  url: string
  currentPage: number
  pagesCount: number
}): Link[] => {
  if (currentPage >= pagesCount) return []
  return [
    {
      rel: 'next',
      href: withQuery(url, { page: currentPage + 1 }),
    },
  ]
}

export const useLinkPrevNext = ({
  pagesCount,
  currentPage,
}: {
  pagesCount: Ref<number>
  currentPage: Ref<number>
}): ComputedRef<Link[]> => {
  const route = useRoute()
  const runtimeConfig = useRuntimeConfig()
  const { baseUrl } = runtimeConfig.public

  return computed(() => {
    const rawPagesCount = unref(pagesCount)
    const rawCurrentPage = unref(currentPage)

    if (!rawPagesCount || !rawCurrentPage || rawPagesCount === 1) return []

    const url = joinURL(baseUrl, replaceWapersCornerSlug(route.path))

    const prevLink = getPrevLink({ url, currentPage: rawCurrentPage })
    const nextLink = getNextLint({
      url,
      currentPage: rawCurrentPage,
      pagesCount: rawPagesCount,
    })

    // Prevent duplicate content
    const canonicalHref =
      rawCurrentPage === 1 ? url : withQuery(url, { page: rawCurrentPage })

    const canonicalLink = {
      rel: 'canonical',
      href: canonicalHref,
    }

    return [...prevLink, ...nextLink, canonicalLink]
  })
}
